<!--公告及新闻稿-->
<template>
  <!--内容-->
  <div class="content_width_box">
    <div class="content_title">
      <div class="title_left_h2">电话会议</div>
    </div>
    <div class="select_box">
      <multiselect v-model="yearSelected" 
        :options="['全部年份',...this.telMeetingList.yearList]" 
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
    </div>
    
    <YearsTitleListView :messageList="telMeetingList.list" :perPage="telMeetingList.perPage" detailRouter="invstorDetail" :yearSelected="yearSelected"></YearsTitleListView>
  </div>  
</template>
<script>

import YearsTitleListView from '../../titleNews/YearsTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorTelMeeting',
    components:{UtilEvent,YearsTitleListView},
    props: ['telMeetingList'],
    created(){
        
    },
    data () {
      return {
        yearSelected:'全部年份',
      }
    },
    computed:{
      
    },
    methods:{
      
      
    },
    watch:{
      
    },
    mounted(){
      
    },
   
  }
  </script>

